import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
} from "@chakra-ui/react";
import { useSearchParams } from "react-router";
import { useCallback, useMemo } from "react";
import { TaskActionContext } from "contexts/TaskActionContext";
import { taskActionLabel } from "features/Resources/Task/helpers";
import { useTaskDetailQuery } from "features/Resources/Task/hooks";
import { TaskActionModalForm } from "./TaskActionForm";

export default function TaskActionModalByQueryParam() {
  const [searchParams, setSearchParams] = useSearchParams();
  const taskId = searchParams.get("task_action");

  const { data: task } = useTaskDetailQuery(taskId || undefined, {
    enabled: !!taskId,
  });

  const handleClose = useCallback(() => {
    searchParams.delete("task_action");
    setSearchParams(searchParams);
  }, [searchParams, setSearchParams]);

  const contextValue = useMemo(() => ({ onClose: handleClose }), [handleClose]);
  const label = taskActionLabel(task?.taskAction);

  if (!taskId) {
    return null;
  }

  return (
    <Modal isOpen onClose={handleClose} size="2xl">
      <ModalOverlay />
      <ModalContent>
        {label && <ModalHeader>{label}</ModalHeader>}
        <ModalCloseButton />
        <ModalBody>
          <TaskActionContext.Provider value={contextValue}>
            <TaskActionModalForm taskId={taskId} />
          </TaskActionContext.Provider>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}
